import pie from "pistacja/plugin";
import Embeds from "embeds";
import Popover from "popover";
import CopyText from "copy-text";
import Accordion from "accordion";
import Transcript from "transcript";
import H5PTracker from "h5p-tracker";
import { queryToObject } from "utils";
import UnicefBanner from "unicef-banner";
import dialogDismiss from "dialog-dismiss";
import usppModal from "pistacja/uspp-modal";
import PerfectScrollbar from "perfect-scrollbar";

// Styles.
import "perfect-scrollbar/css/perfect-scrollbar.css";

pie.plugin(async function Player({ $, $$, lsm, device, domain }) {
  // Dismiss dialog when user clicks on backdrop.
  dialogDismiss();

  // Add H5P xAPI listensers.
  H5PTracker(
    "/api/saveExerciseOperation",
    process.env.NODE_ENV === "production" ? "--mute" : ""
  );

  // Activete popovers.
  Popover();

  // Activate UNICEFF banner.
  UnicefBanner("#unicef-banner", "#yt-player", "#video-accordion-trigger");

  // USPP modal.
  usppModal("#usppModal", domain);

  // Get playlsit reference.
  const playlist = $("#playlist-accordion-content .pie-perfect-scroll-list");

  // Enable accordions.
  Accordion();

  // Set active accordion.
  $(
    queryToObject(window.location.search).ref === "playlist"
      ? "#playlist-accordion-trigger"
      : "#video-accordion-trigger"
  ).click();

  // Hack to prevent accordion animation on page load when JS is selecting proper tab.
  setTimeout(() => $(".pie-player").classList.remove("no-tansition"), 300);

  // Coopy text to clipboard.
  CopyText().add({
    trigger: "#transcript-copy-button",
    message: pie_i18n.PIE_JS_TRANSCRIPT_COPY_TEXT,
    source: $("#transcriptContent").textContent.replace(/\s+/, " "),
  });

  // Handle Embeds.
  Embeds("#embeds");

  // Connect transcript with YouTube Player.
  Transcript("#transcriptContent", "#yt-player");

  // Handle Desktop & Mobile logic respectively.
  device({
    onDesktop() {
      // Apply Perfect Scrollbars.
      const scrollbars = $$(".pie-perfect-scroll-list").map((list) => {
        const ps = new PerfectScrollbar(list);
        if (playlist === list) {
          list.scrollTop = lsm.get("playlistOffset") || 0;
        }
        return ps;
      });

      // Save playlist scroll position to maintain it when user navigates to the next item on the playlist.
      window.onbeforeunload = () => {
        lsm.set("playlistOffset", playlist.scrollTop);
      };

      // Cleanup.
      return () => {
        scrollbars.forEach((ps) => ps.destroy());
      };
    },

    onMobile() {
      const sidenav = $(".pie-player-sidenav");

      sidenav.onclick = (event) => {
        // Scroll active-button into top of the screen when after accordions are switched the active-button overflows top of the screen.
        if (
          event.target.matches(
            "button:not([aria-expanded=true], [data-mobile-snap=false])"
          )
        ) {
          // 300ms is the time of the accordion's transition, 64px is minimal top offset accounting mobile nav.
          setTimeout(
            () =>
              event.target.getBoundingClientRect().top < 64 &&
              event.target.scrollIntoView(),
            350
          );
        }
      };

      // Cleanup.
      return () => {
        sidenav.onclick = null;
      };
    },
  });
});
